

















































import {Component, Vue} from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import SenderSelector from '@/components/user/SenderSelector.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import DepartmentSelector from '@/components/department/DepartmentSelector.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import YearMonthPicker from '@/components/datepicker/YearMonthPicker.vue';
import {progress} from '@/script/progress';

import moment from 'moment';
import aggregateStockApi from '@/infrastructure/api/custom/keiaikai/AggregateStockApi';

import {loginModule} from '@/store/authentication/login';
import {在庫集計表出力条件型} from '@/type/custom/keiaikai/stock/在庫集計表出力条件型';
import 在庫集計表出力条件チェッカー from '@/type/custom/keiaikai/stock/validator/在庫集計表出力条件チェッカー';
import {部署型} from '@/type/department/department';

@Component({
  components: {
    YearMonthPicker,
    NormalButton,
    ConfirmDialog,
    DepartmentSelector,
    ButtonPanel,
    IconButton,
    SenderSelector,
    AlertDialog,
  },
  filters: {
    日付のフォーマット(date: Date): string | null {
      if (!date) {
        return '';
      }
      return moment(date).format('YYYY/MM/DD');
    },
  },
})
export default class AggregateWithdraw extends Vue {
  // data
  在庫集計部署一覧: 部署型[] = [];

  出力条件: 在庫集計表出力条件型 = {
    在庫集計年月: moment().format('YYYY-MM'),
    在庫集計部署: '',
  };

  アラートメッセージ: string[] | string | null = null;

  checker: 在庫集計表出力条件チェッカー | null = null;

  // methods
  在庫集計表出力確認ダイアログを開く(): void {
    this.checker = new 在庫集計表出力条件チェッカー(this.出力条件);
    if (this.checker.hasErrors()) {
      this.alert(this.checker.errorMessages());
      return;
    }
    this.ダイアログを開く('在庫集計表出力確認ダイアログ');
  }

  ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  在庫集計表をダウンロードするハンドラ() {
    this.ダイアログを閉じる('在庫集計表出力確認ダイアログ');
    progress(this.在庫集計表をダウンロードする);
  }

  async 在庫集計表をダウンロードする() {
    await aggregateStockApi.在庫集計表をダウンロードする(this.出力条件)
      .catch((error: any) => {
        if (!error.data.errors) {
          this.alert(error.data.message);
        }
        if (error.data.errors) {
          this.alert(error.data.errors);
        }
      });
  }

  alert(message: string[] | string | null): void {
    this.アラートメッセージ = message;
    this.$modal.show('在庫集計アラート');
  }

  async 在庫集計部署を取得する() {
    this.在庫集計部署一覧 = await api.部署一覧を取得する();
    if (this.在庫集計部署一覧.length > 0) {
      this.出力条件.在庫集計部署 = this.在庫集計部署一覧[0].部署コード;
    }
  }

  // lifecycle hook
  created(): void {
    this.在庫集計部署を取得する();
  }
}
